import { render, staticRenderFns } from "./lyMyCenter.vue?vue&type=template&id=3f5e9706&"
import script from "./lyMyCenter.vue?vue&type=script&lang=js&"
export * from "./lyMyCenter.vue?vue&type=script&lang=js&"
import style0 from "./lyMyCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports